import React, { useEffect, useState } from "react"
import "./timeDelayedModal.scss"

const TimeDelayedModal = (props) => {
  const { delayInSeconds, children, modalWidth } = props
  const [isOpen, setIsOpen] = useState(false)

  const onClose = () => setIsOpen(false)

  const delayInMilliseconds = delayInSeconds * 1000

  useEffect(() => {
    setTimeout(() => setIsOpen(true), delayInMilliseconds)
  }, [])

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onClose })
    }
    return child
  })

  if (isOpen) {
    return (
      <div className="time-delayed-modal-overlay" data-cy="timed-modal">
        <div
          className="time-delayed-modal-container"
          style={{
            width: modalWidth || "50%",
          }}
        >
          {childrenWithProps}
        </div>
      </div>
    )
  }

  return null
}

export default TimeDelayedModal
